import Link from 'next/link';
import classNames from 'classnames';
import classes from './ButtonLink.module.css';

type Props = {
   href: string;
   children: JSX.Element | JSX.Element[] | string;
   className?: string;
   outlined?: boolean;
};

const ButtonLink = ({ href, children, outlined, className }: Props) => (
   <Link href={href}>
      <a
         className={classNames(
            classes.buttonLink,
            { [classes.filled]: !outlined },
            { [classes.outlined]: outlined },
            className,
         )}
      >
         {children}
      </a>
   </Link>
);

export default ButtonLink;
